import React, { Component } from 'react';
import _ from 'lodash'
import './MatchupGame.css'
import './MatchupFight.css'

class MatchupFight extends Component {
  state = {
    event: _.get(this.props.api, 'LiveEvents[0]')
  }

  initializeProps = () => {
    this.header = `<div>
      <span>Strikes Landed / Thrown</span>
      <span>Arm Strikes Landed / Thrown</span>
      <span>Leg Strikes Landed / Thrown</span>
      <span>Ground Strikes Landed / Thrown</span>
      <span>Takedowns / Attempts</span>
      <span>Submission Attempts</span>
      <span>Knockdowns</span>
      <span>Dominant Positions</span>
    </div>`

    let buttons = document.querySelectorAll('.button')

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        let ctn = btn.nextElementSibling
        if (_.includes(ctn.className, 'toggled')) {
          btn.className = 'button'
          ctn.className = 'stats-container'
        } else {
          btn.className = 'button toggled'
          ctn.className = 'stats-container toggled'
        }
      }, false)
      let ctn = btn.nextElementSibling
      let fight = _.find(this.state.event.Fights, { FightId: btn.getAttribute('data-fight') })
      let merged = this.mergeRounds(fight)
      this.appendToPage(merged, ctn)
    })
  }
  
  componentDidMount = () => {
    this.initializeProps()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.api !== prevProps.api) {
      this.initializeProps()
    }
  }

  mergeRounds = (fight) => {
    function customizer(objValue, srcValue, key) {
      if (!_.isObject(objValue) && key !== 'FighterId') {
        return (+objValue) + (+srcValue);
      }
    }

    let f1 = []
    let f2 = []
    let results = []
    f1.push(fight.Rounds.filter(el => el.FighterId === fight.Fighter1_Id))
    f2.push(fight.Rounds.filter(el => el.FighterId === fight.Fighter2Id))
    let fighters = [f1, f2]

    for (let i = 0; i < fighters.length; i++) {
      for (let j = 0, r = fighters[i].length; j < r; j++) {
        if (fighters[i][j].length) {
          let copy = fighters[i][j].map(el => el)
          let dest = copy.slice(0, 1)
          let rest = copy.slice(1, copy.length - 1)
          results.push(_.mergeWith(dest[0], ...rest, customizer))
        }
      }
    }
    return results
  }

  appendToPage = (data, ctn) => {
    let divs = []
    data.forEach(d => {
      let div = `<div>
        <span>${+d.TotalArmStrikesThrown + +d.TotalLegStrikesThrown} / ${+d.TotalStrikesThrown}</span>
        <span>${+d.NonPowerArmStrikesLanded + +d.PowerArmStrikesLanded} / ${+d.TotalArmStrikesThrown}</span>
        <span>${+d.NonPowerLegStrikesLanded + +d.PowerLegStrikesLanded} / ${+d.TotalLegStrikesThrown}</span>
        <span>${+d.PowerGroundStrikesLanded} / ${+d.GroundStrikesThrown}</span>
        <span>${+d.Takedowns} / ${+d.TakedownAttempts}</span>
        <span>${+d.SubmissionAttempts}</span>
        <span>${+d.Knockdowns}</span>
        <span>${+d.DominantPositions}</span>
      </div>`
      divs.push(div)
    })
    ctn.innerHTML = _.isEmpty(divs[0]) ? 
    `<div><span>No data yet.</span></div>` : 
    divs[0] + this.header + divs[1]
  }

  render() {
    return (
      <div className='matchup-wrapper fight-detail'>
        <div className='preview' style={{ 'width': '100%' }}>
          <h3 className='preview-title site-border-color'>Preview</h3>
          <div className='preview-paragraph' dangerouslySetInnerHTML={{
            __html: `${this.props.page.details || 'Coming soon.'}`
          }} />
        </div>
      </div>
    )
  }
}

export default MatchupFight;